import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FC } from 'react';

interface FontAwesomeLayeredProps {
  icon1: any;
  icon2: any;
  className?: string;
  transform2?: string;
}

const FontAwesomeLayered: FC<FontAwesomeLayeredProps> = (props) => {
  return (
    <span className={'fa-layers fa-fw ' + (props.className ? props.className : '')}>
      <FontAwesomeIcon icon={props.icon1} transform="left-6 shrink-2" />
      <FontAwesomeIcon
        icon={props.icon2}
        transform={props.transform2 ? props.transform2 : 'shrink-6 down-5 right-4'}
        style={{ color: 'white', scale: '1.2' }}
      />
      <FontAwesomeIcon
        icon={props.icon2}
        transform={props.transform2 ? props.transform2 : 'shrink-6 down-5 right-4'}
      />
    </span>
  );
};

export default FontAwesomeLayered;
